/**
 * DISC chart conversion tables.
 *
 * Input values are raw scores. Output values are the plotted Y values used by
 * the DISC charts. Keep these tables as lookup data; do not replace them with
 * a linear formula because every graph type has its own norm table.
 *
 * The values below are integer chart-grid values derived from the existing
 * Software_DISC.xlsx norm table and rounded to match the reference DISC grid.
 * If your printed/reference image uses a different standard, edit this file
 * directly per graph type and per dimension.
 */

export const DISC_TRAITS = ["D", "I", "S", "C"];

export const DISC_MOST_CONVERSION = {
  D: {
    0: -6,
    1: -5,
    2: -4,
    3: -2,
    4: -2,
    5: -1,
    6: 0,
    7: 1,
    8: 1,
    9: 2,
    10: 3,
    11: 4,
    12: 4,
    13: 5,
    14: 5,
    15: 7,
    16: 7,
    17: 7,
    18: 7,
    19: 8,
    20: 8,
  },
  I: {
    0: -7,
    1: -5,
    2: -2,
    3: -1,
    4: 1,
    5: 3,
    6: 4,
    7: 5,
    8: 6,
    9: 6,
    10: 7,
    11: 7,
    12: 7,
    13: 7,
    14: 7,
    15: 7,
    16: 8,
    17: 8,
    18: 8,
    19: 8,
    20: 8,
  },
  S: {
    0: -6,
    1: -4,
    2: -3,
    3: -1,
    4: -1,
    5: 1,
    6: 1,
    7: 3,
    8: 3,
    9: 4,
    10: 5,
    11: 5,
    12: 6,
    13: 6,
    14: 7,
    15: 7,
    16: 7,
    17: 7,
    18: 7,
    19: 8,
    20: 8,
  },
  C: {
    0: -6,
    1: -5,
    2: -3,
    3: -1,
    4: 1,
    5: 2,
    6: 3,
    7: 5,
    8: 6,
    9: 6,
    10: 6,
    11: 7,
    12: 7,
    13: 7,
    14: 7,
    15: 7,
    16: 7,
    17: 8,
    18: 8,
    19: 8,
    20: 8,
  },
};

export const DISC_LEAST_CONVERSION = {
  D: {
    0: 8,
    1: 7,
    2: 4,
    3: 3,
    4: 2,
    5: 1,
    6: 0,
    7: -1,
    8: -1,
    9: -2,
    10: -3,
    11: -3,
    12: -4,
    13: -5,
    14: -6,
    15: -6,
    16: -6,
    17: -7,
    18: -7,
    19: -7,
    20: -7,
  },
  I: {
    0: 7,
    1: 6,
    2: 4,
    3: 3,
    4: 1,
    5: 0,
    6: -2,
    7: -3,
    8: -4,
    9: -5,
    10: -6,
    11: -6,
    12: -7,
    13: -7,
    14: -7,
    15: -7,
    16: -7,
    17: -7,
    18: -7,
    19: -7,
    20: -8,
  },
  S: {
    0: 8,
    1: 7,
    2: 6,
    3: 4,
    4: 3,
    5: 2,
    6: 1,
    7: -1,
    8: -2,
    9: -3,
    10: -4,
    11: -5,
    12: -6,
    13: -6,
    14: -7,
    15: -7,
    16: -7,
    17: -7,
    18: -7,
    19: -7,
    20: -8,
  },
  C: {
    0: 8,
    1: 7,
    2: 6,
    3: 4,
    4: 3,
    5: 2,
    6: 1,
    7: 0,
    8: -1,
    9: -2,
    10: -3,
    11: -5,
    12: -6,
    13: -6,
    14: -6,
    15: -7,
    16: -7,
    17: -7,
    18: -8,
    19: -8,
    20: -8,
  },
};

export const DISC_CHANGE_CONVERSION = {
  D: {
    "-22": -8,
    "-21": -7,
    "-20": -7,
    "-19": -7,
    "-18": -7,
    "-17": -7,
    "-16": -6,
    "-15": -6,
    "-14": -6,
    "-13": -6,
    "-12": -6,
    "-11": -5,
    "-10": -4,
    "-9": -3,
    "-8": -3,
    "-7": -3,
    "-6": -3,
    "-5": -2,
    "-4": -1,
    "-3": -1,
    "-2": 0,
    "-1": 0,
    0: 0,
    1: 1,
    2: 1,
    3: 1,
    4: 1,
    5: 2,
    6: 2,
    7: 3,
    8: 4,
    9: 4,
    10: 5,
    11: 5,
    12: 5,
    13: 6,
    14: 6,
    15: 6,
    16: 7,
    17: 7,
    18: 7,
    19: 7,
    20: 7,
    21: 8,
    22: 8,
  },
  I: {
    "-22": -8,
    "-21": -8,
    "-20": -8,
    "-19": -8,
    "-18": -7,
    "-17": -7,
    "-16": -7,
    "-15": -7,
    "-14": -7,
    "-13": -7,
    "-12": -7,
    "-11": -7,
    "-10": -6,
    "-9": -6,
    "-8": -6,
    "-7": -5,
    "-6": -4,
    "-5": -3,
    "-4": -3,
    "-3": -2,
    "-2": -1,
    "-1": 0,
    0: 1,
    1: 1,
    2: 2,
    3: 3,
    4: 4,
    5: 4,
    6: 5,
    7: 6,
    8: 7,
    9: 7,
    10: 7,
    11: 7,
    12: 7,
    13: 7,
    14: 7,
    15: 7,
    16: 7,
    17: 7,
    18: 8,
    19: 8,
    20: 8,
    21: 8,
    22: 8,
  },
  S: {
    "-22": -8,
    "-21": -8,
    "-20": -8,
    "-19": -8,
    "-18": -7,
    "-17": -7,
    "-16": -7,
    "-15": -7,
    "-14": -6,
    "-13": -6,
    "-12": -6,
    "-11": -6,
    "-10": -6,
    "-9": -5,
    "-8": -4,
    "-7": -3,
    "-6": -3,
    "-5": -2,
    "-4": -1,
    "-3": -1,
    "-2": 0,
    "-1": 0,
    0: 1,
    1: 2,
    2: 2,
    3: 3,
    4: 4,
    5: 4,
    6: 4,
    7: 5,
    8: 5,
    9: 6,
    10: 6,
    11: 6,
    12: 6,
    13: 7,
    14: 7,
    15: 7,
    16: 7,
    17: 7,
    18: 7,
    19: 7,
    20: 8,
    21: 8,
    22: 8,
  },
  C: {
    "-22": -7,
    "-21": -7,
    "-20": -7,
    "-19": -7,
    "-18": -7,
    "-17": -7,
    "-16": -7,
    "-15": -6,
    "-14": -6,
    "-13": -6,
    "-12": -6,
    "-11": -6,
    "-10": -6,
    "-9": -5,
    "-8": -4,
    "-7": -3,
    "-6": -3,
    "-5": -2,
    "-4": 0,
    "-3": 0,
    "-2": 0,
    "-1": 1,
    0: 2,
    1: 3,
    2: 4,
    3: 4,
    4: 6,
    5: 6,
    6: 6,
    7: 6,
    8: 7,
    9: 7,
    10: 7,
    11: 7,
    12: 7,
    13: 7,
    14: 7,
    15: 7,
    16: 7,
    17: 8,
    18: 8,
    19: 8,
    20: 8,
    21: 8,
    22: 8,
  },
};

export const DISC_NORM_TABLE = {
  MOST: {
    D: {
      8: ["21", "16", "15"],
      6: ["14", "13"],
      4: ["12", "11", "10", "9"],
      2: ["8", "7"],
      0: ["6", "5", "4"],
      "-2": ["3"],
      "-4": ["1"],
      "-6": ["0"],
    },
    I: {
      8: ["19", "11", "9"],
      6: ["8", "7"],
      4: ["6", "5"],
      2: ["4"],
      0: ["3"],
      "-2": ["2"],
      "-4": ["1"],
      "-6": ["0"],
    },
    S: {
      8: ["20", "14"],
      6: ["12", "10"],
      4: ["9", "8", "7"],
      2: ["6", "5"],
      0: ["4", "3"],
      "-2": ["2"],
      "-4": ["1", "0"],
      "-6": [],
    },
    C: {
      8: ["17", "13", "11"],
      6: ["9", "8", "7"],
      4: ["6", "5"],
      2: ["4"],
      0: ["3"],
      "-2": ["2"],
      "-4": ["1"],
      "-6": ["0"],
    },
  },
  LEAST: {
    D: {
      8: ["0", "1"],
      6: ["2"],
      4: ["3"],
      2: ["4", "5"],
      0: ["6", "7", "8"],
      "-2": ["9", "10", "11"],
      "-4": ["12", "13", "14"],
      "-6": ["15", "16", "20"],
    },
    I: {
      8: ["0"],
      6: ["1"],
      4: ["2", "3"],
      2: ["4"],
      0: ["5"],
      "-2": ["6", "7"],
      "-4": ["8", "9"],
      "-6": ["10", "11", "12", "19"],
    },
    S: {
      8: ["0", "1"],
      6: ["2"],
      4: ["3", "4"],
      2: ["5", "6"],
      0: ["7"],
      "-2": ["8"],
      "-4": ["10", "11"],
      "-6": ["12", "13", "16", "19"],
    },
    C: {
      8: ["0", "1"],
      6: ["2"],
      4: ["3", "4"],
      2: ["5", "6"],
      0: ["7", "8"],
      "-2": ["9", "10"],
      "-4": ["11", "12"],
      "-6": ["13", "15", "17"],
    },
  },
  CHANGE: {
    D: {
      8: ["21", "18", "15", "14"],
      6: ["13", "12", "10"],
      4: ["9", "8", "7"],
      2: ["5", "3", "1"],
      0: ["0", "-2", "-3", "-4"],
      "-2": ["-6", "-7", "-9"],
      "-4": ["-10", "-11", "-12"],
      "-6": ["-16", "-20"],
    },
    I: {
      8: ["18", "10", "8"],
      6: ["7", "6", "5"],
      4: ["4", "3"],
      2: ["2", "1", "0"],
      0: ["-1", "-2", "-3"],
      "-2": ["-4", "-5"],
      "-4": ["-6", "-7", "-8"],
      "-6": ["-9", "-10", "-18"],
    },
    S: {
      8: ["20", "15", "11", "10"],
      6: ["9", "8", "7"],
      4: ["5", "4", "3", "2"],
      2: ["1", "0"],
      0: ["-1", "-2", "-3", "-4", "-5"],
      "-2": ["-6", "-7"],
      "-4": ["-8", "-9"],
      "-6": ["-10", "-15", "-18"],
    },
    C: {
      8: ["17", "10", "6", "5"],
      6: ["4", "3"],
      4: ["2"],
      2: ["0", "-1", "-2"],
      0: ["-3", "-4"],
      "-2": ["-5", "-6", "-7"],
      "-4": ["-8", "-9", "-10"],
      "-6": ["-13", "-15", "-19", "-22"],
    },
  },
};

export const DISC_CONVERSIONS = {
  MOST: DISC_MOST_CONVERSION,
  LEAST: DISC_LEAST_CONVERSION,
  CHANGE: DISC_CHANGE_CONVERSION,
};

const toRawRowTable = (conversion) => {
  const rawKeys = [
    ...new Set(
      DISC_TRAITS.flatMap((trait) =>
        Object.keys(conversion[trait] || {}).map(Number)
      )
    ),
  ].sort((a, b) => a - b);

  return rawKeys.reduce((rows, rawKey) => {
    rows[rawKey] = DISC_TRAITS.reduce((row, trait) => {
      row[trait] = conversion[trait]?.[rawKey] ?? conversion[trait]?.[String(rawKey)] ?? 0;
      return row;
    }, {});
    return rows;
  }, {});
};

// Backward-compatible row-shaped exports for older code paths.
export const MOST_TABLE = toRawRowTable(DISC_MOST_CONVERSION);
export const LEAST_TABLE = toRawRowTable(DISC_LEAST_CONVERSION);
export const CHANGE_TABLE = toRawRowTable(DISC_CHANGE_CONVERSION);
